export default "__VITE_ASSET__BoV_7OWt__"